export default __webpack_public_path__ + "static/media/export_banner.91b17265.svg";